import { render } from "./EmptyWhatsNew.vue?vue&type=template&id=fc895c56&scoped=true"
import script from "./EmptyWhatsNew.vue?vue&type=script&lang=js"
export * from "./EmptyWhatsNew.vue?vue&type=script&lang=js"

import "./EmptyWhatsNew.vue?vue&type=style&index=0&id=fc895c56&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc895c56"]])

export default __exports__